import React, { useState, useEffect } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import TeamApiKeysHeader from 'team/components/adminApiKeys/TeamApiKeysHeader';
import TeamApiKeysList from 'team/components/adminApiKeys/TeamApiKeysList';
import TeamCreateApiKeyModal from 'team/components/adminApiKeys/TeamCreateApiKeyModal';
import { useTeam } from 'team/contexts/teamContext';
import { getTeamApiKeys } from 'team/apis/teamApi';

const TeamAdminApiKeysContainer = () => {
    const { currentTeamId } = useTeam();
    const [apiKeys, setApiKeys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [createOpen, setCreateOpen] = useState(false);

    const fetchApiKeys = async () => {
        if (!currentTeamId) return;
        setLoading(true);
        setError('');
        try {
            const response = await getTeamApiKeys(currentTeamId);
            if (response && response.success) {
                setApiKeys(response.apiKeys);
            }
        } catch (err) {
            console.error('Failed to fetch API keys:', err);
            setError(err.message || 'Failed to fetch API keys');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (currentTeamId) {
            fetchApiKeys();
        }
    }, [currentTeamId]);

    const handleCreateClick = () => {
        setCreateOpen(true);
    };

    return (
        <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                    API Keys
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                    ({apiKeys.length})
                </Typography>
                <Typography variant="body2" sx={{ color: '#828282', maxWidth: '600px' }}>
                    Create and manage API keys to connect Touch to your external tools and integrations.
                </Typography>
            </Box>

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            <Box sx={{ flexGrow: 1 }}>
                <TeamApiKeysHeader
                    count={apiKeys.length}
                    onCreate={handleCreateClick}
                />

                <TeamApiKeysList
                    apiKeys={apiKeys}
                    loading={loading}
                    onRefresh={fetchApiKeys}
                />
            </Box>

            <TeamCreateApiKeyModal
                open={createOpen}
                onClose={() => setCreateOpen(false)}
                onSuccess={fetchApiKeys}
            />
        </Box>
    );
};

export default TeamAdminApiKeysContainer;
